import React from 'react';
import Instructions from './Instructions';
import BackToSignInContainer from './BackToSignInContainer';

const CheckYourInBox = () => {
  const instructionsProps = {
    text: `We've sent an email with instructions to reset your password. If you don't see
  the email, please be sure to check your spam or junk mail folder.`,
  };
  return (
    <article>
      <div className="box">
        <div className="pa3 cf">
          <h1 className="flex f4 f3-ns mb4" id="announcement">
            <i className="material-icons green mr1 self-center" id="sizzle">
              check_circle
            </i>
            Check your inbox.
          </h1>
          <Instructions {...instructionsProps} />
          <BackToSignInContainer />
        </div>
      </div>
    </article>
  );
};

export default CheckYourInBox;
